import React, { Component } from 'react';

import { LayoutContext } from '../../../../../modules/ContextModules/LayoutContext';

import deletePng from './.image/清除圖案.png';
import optionPng from './.image/選單圖案.png';

import './BuildingItem.css'

export class BuildingItem extends Component {
    static contextType = LayoutContext;
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
        }

    }

    componentDidMount() {
    }

    locate(layer) {
        if (layer != null)
            layer.goto();
    }

    remove(index) {

    }

    render() {
        const { buildingToolContext } = this.context;
        let item = buildingToolContext.buildingList[this.props.index];
        return (
            <div className="buildingItem-Box">
                <div className='buildingItem'>
                    <span>{this.props.name}</span>
                    <button className='buildingItem-btn' onClick={() => { this.setState({ isOpen: !this.state.isOpen }) }}>選單</button>
                </div>
                {this.state.isOpen ?
                    <div className="buildingItem-option">
                        {this.props.type === "I3S" ? <>不透明度:
                            <input type="range" min="0" max="100" value={item.opacity * 100} onChange={(e) => { buildingToolContext.setOpacity(this.props.index, e.target.value / 100); }} />
                        </> : null}
                        <button className='buildingItem-btn' onClick={() => { this.locate(this.props.layer) }}>定位</button>
                        <img src={deletePng} onClick={() => { buildingToolContext.remove(this.props.index); }} alt="delete" />
                    </div> : null
                }
            </div>
        );
    }
}
